import React from 'react';
import { Box, Typography, Grid, Paper, Card, CardContent, IconButton, List, ListItem, ListItemText, ListItemSecondaryAction } from '@mui/material';
import { styled } from '@mui/material/styles';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import TimerIcon from '@mui/icons-material/Timer';
import EditIcon from '@mui/icons-material/Edit';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  height: '100%',
}));

const TimerDisplay = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(2),
}));

const Conductors: React.FC = () => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="h4" gutterBottom>
        Conducteurs d'émissions
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <StyledPaper>
            <Typography variant="h6" gutterBottom>
              Conducteur en cours
            </Typography>
            <TimerDisplay>
              <TimerIcon sx={{ mr: 1 }} />
              <Typography variant="h3" component="span">
                00:45:30
              </Typography>
            </TimerDisplay>
            <List>
              {[
                { time: '16:00', title: 'Journal', duration: '30:00', status: 'completed' },
                { time: '16:30', title: 'Magazine Culture', duration: '45:00', status: 'current' },
                { time: '17:15', title: 'Publicités', duration: '05:00', status: 'upcoming' },
                { time: '17:20', title: 'Documentaire', duration: '60:00', status: 'upcoming' },
              ].map((item, index) => (
                <ListItem
                  key={index}
                  sx={{
                    bgcolor: item.status === 'current' ? 'action.selected' : 'transparent',
                    borderLeft: (theme) => `4px solid ${
                      item.status === 'completed' ? theme.palette.success.main :
                      item.status === 'current' ? theme.palette.primary.main :
                      'transparent'
                    }`,
                  }}
                >
                  <ListItemText
                    primary={item.title}
                    secondary={`${item.time} - Durée: ${item.duration}`}
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="edit">
                      <EditIcon />
                    </IconButton>
                    {item.status === 'current' && (
                      <IconButton edge="end" aria-label="play" sx={{ ml: 1 }}>
                        <PlayArrowIcon />
                      </IconButton>
                    )}
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </StyledPaper>
        </Grid>

        <Grid item xs={12} md={4}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Prochain conducteur
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Programme du soir - 20:00
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Statistiques
                  </Typography>
                  <List>
                    <ListItem>
                      <ListItemText
                        primary="Temps d'antenne"
                        secondary="98% utilisé"
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary="Conducteurs aujourd'hui"
                        secondary="12 complétés"
                      />
                    </ListItem>
                  </List>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Conductors;
